{
  "consent.action-accept": "Tillåt",
  "consent.action-reject": "Neka",
  "consent.description": "Ge bara behörigheter om du litar på den här webbplatsen eller appen. Du behöver inte acceptera alla behörigheter.",
  "consent.privacy-policy-label": "Integritetspolicy",
  "consent.remember-label": "Kom ihåg detta val till nästa gång. Applikationen kommer inte att kunna be om ytterligare tillstånd utan ditt medgivande.",
  "consent.remember-tooltip": "kom ihåg mitt val",
  "consent.requested-permissions-label": "Applikationen begär åtkomst till följande behörigheter:",
  "consent.terms-of-service-label": "Användarvillkor",
  "error.back-button": "Tillbaka",
  "error.description": "Ett fel uppstod med följande meddelande:",
  "error.support-email-link": "Om problemet kvarstår, vänligen kontakta <a>{contactSupportEmail}</a>",
  "error.title": "Ett fel uppstod",
  "error.title-internal-server-error": "Internt serverfel",
  "error.title-not-found": "404 - Sidan hittades ej",
  "identities.messages.1010001": "Logga in",
  "identities.messages.1010002": "Logga in med {provider}",
  "identities.messages.1010003": "Bekräfta denna åtgärd genom att verifiera att det är du.",
  "identities.messages.1010004": "Vänligen slutför den andra autentiseringsutmaningen.",
  "identities.messages.1010005": "Verifiera",
  "identities.messages.1010006": "Autentiseringskod",
  "identities.messages.1010007": "Återställningskod för backup",
  "identities.messages.1010008": "Fortsätt med säkerhetsnyckel",
  "identities.messages.1010009": "Fortsätt",
  "identities.messages.1010010": "Fortsätt",
  "identities.messages.1010011": "Fortsätt med säkerhetsnyckel",
  "identities.messages.1010012": "Förbered din WebAuthn-enhet (t.ex. säkerhetsnyckel, biometriska skanner, ...) och tryck på fortsätt.",
  "identities.messages.1010013": "Fortsätt",
  "identities.messages.1010014": "Ett e-postmeddelande som innehåller en kod har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen av adressen och försök logga in igen.",
  "identities.messages.1010015": "Logga in med kod",
  "identities.messages.1010016": "Du försökte logga in med \"{duplicateIdentifier}\", men den e-postadressen används redan av ett annat konto. Logga in på ditt konto med ett av alternativen nedan för att lägga till ditt konto \"{duplicateIdentifier}\" hos \"{provider}\" som ett annat inloggningsalternativ.",
  "identities.messages.1010017": "Logga in och länka",
  "identities.messages.1010018": "Bekräfta med {provider}",
  "identities.messages.1010019": "Begär kod för att fortsätta",
  "identities.messages.1010021": "Logga in med passkey",
  "identities.messages.1010022": "Logga in med lösenord",
  "identities.messages.1010023": "Skicka kod till {address}",
  "identities.messages.1040001": "Skapa konto",
  "identities.messages.1040002": "Registrera dig med {provider}",
  "identities.messages.1040003": "Fortsätt",
  "identities.messages.1040004": "Registrera med säkerhetsnyckel",
  "identities.messages.1040005": "Ett e-postmeddelande som innehåller en kod har skickats till den e-postadress du angett. Om du inte har fått ett e-postmeddelande, kontrollera stavningen av adressen och försök igen med registreringen.",
  "identities.messages.1040006": "Registrera med kod",
  "identities.messages.1040007": "Registrera med passkey",
  "identities.messages.1040008": "Tillbaka",
  "identities.messages.1040009": "Vänligen välj en autentiseringsmetod.",
  "identities.messages.1050001": "Dina ändringar har sparats!",
  "identities.messages.1050002": "Koppla på {provider}",
  "identities.messages.1050003": "Koppla bort {provider}",
  "identities.messages.1050004": "Koppla bort TOTP Autentisering-App",
  "identities.messages.1050005": "Autentisering-app QR kod",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "Visa reservåterställningskoder",
  "identities.messages.1050008": "Generera nya reservåterställningskoder",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "Det här är dina reservåterställningskoder. Förvara dem på ett säkert ställe!",
  "identities.messages.1050011": "Bekräfta reservåterställningskoder",
  "identities.messages.1050012": "Lägg till säkerhetsnyckel",
  "identities.messages.1050013": "Säkerhetsnyckelns namn",
  "identities.messages.1050014": "<del>Använd</del>",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "Inaktivera den här metoden",
  "identities.messages.1050017": "Det här är din hemlighet för din autentiseringsapp. Använd den om du inte kan skanna QR-koden.",
  "identities.messages.1050018": "Ta bort säkerhetsnyckel \"{display_name}\"",
  "identities.messages.1050019": "Lägg till passkey",
  "identities.messages.1050020": "Ta bort passkey \"{display_name}\"",
  "identities.messages.1060001": "Du har lyckats återställa ditt konto. Ändra ditt lösenord eller ställ in en alternativ inloggningsmetod (t.ex. social inloggning) inom de närmaste {privileged_session_expires_at_unix_until_minutes} minuterna.",
  "identities.messages.1060002": "Ett e-postmeddelande som innehåller en återställningslänk har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.1060003": "Ett e-postmeddelande som innehåller en återställningskod har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.1070001": "Lösenord",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "Spara",
  "identities.messages.1070004": "ID",
  "identities.messages.1070005": "Skicka",
  "identities.messages.1070006": "Verifiera kod",
  "identities.messages.1070007": "E-post",
  "identities.messages.1070008": "Skicka koden igen",
  "identities.messages.1070009": "Fortsätt",
  "identities.messages.1070010": "Återställningskod",
  "identities.messages.1070011": "Verifieringskod",
  "identities.messages.1070012": "Registreringskod",
  "identities.messages.1070013": "Inloggningskod",
  "identities.messages.1070014": "Logga in och länka autentiseringsuppgifter",
  "identities.messages.1070015": "Vänligen slutför captcha-utmaningen för att fortsätta.",
  "identities.messages.1080001": "Ett e-postmeddelande med en verifieringslänk har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.1080002": "Du har verifierat din e-postadress.",
  "identities.messages.1080003": "Ett e-postmeddelande som innehåller en verifieringskod har skickats till den e-postadress du angett. Om du inte har fått ett mejl, kontrollera stavningen på adressen och se till att använda adressen du registrerade dig med.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "Fyll i {property} och försök igen.",
  "identities.messages.4000003": "längd måste vara >= {min_length}, men var {actual_length}",
  "identities.messages.4000004": "matchar inte mönstret \"{pattern}\"",
  "identities.messages.4000005": "Lösenordet kan inte användas pga {reason}.",
  "identities.messages.4000006": "De angivna uppgifterna är ogiltiga. Kontrollera om det finns stavfel i ditt lösenord eller användarnamn, e-postadress eller telefonnummer.",
  "identities.messages.4000007": "Ett konto med samma identifierare (e-post, telefon, användarnamn, ...) finns redan.",
  "identities.messages.4000008": "Den angivna autentiseringskoden är ogiltig, försök igen.",
  "identities.messages.4000009": "Det gick inte att hitta några inloggningsidentifierare. Har du glömt att ställa in dem? Detta kan också orsakas av en felaktig serverkonfiguration.",
  "identities.messages.4000010": "Kontot är inte aktivt ännu. Har du glömt att verifiera din e-postadress?",
  "identities.messages.4000011": "Du har ingen TOTP-enhet konfigurerad.",
  "identities.messages.4000012": "Denna backup-återställningskod har redan använts.",
  "identities.messages.4000013": "Du har ingen WebAuthn-enhet konfigurerad.",
  "identities.messages.4000014": "Du har inga backup-återställningskoder konfigurerade.",
  "identities.messages.4000015": "Det här kontot finns inte eller har ingen säkerhetsnyckel konfigurerad.",
  "identities.messages.4000016": "Backup-återställningskoden är inte giltig.",
  "identities.messages.4000017": "längd måste vara <= {max_length}, men var {actual_length}",
  "identities.messages.4000018": "måste vara >= {minimum} men var {actual}",
  "identities.messages.4000019": "måste vara > {minimum} men var {actual}",
  "identities.messages.4000020": "måste vara <= {maximum} men var {actual}",
  "identities.messages.4000021": "måste vara < {maximum} men var {actual}",
  "identities.messages.4000022": "{actual} är inte en multipel av {base}",
  "identities.messages.4000023": "maximalt {max_items} objekt tillåtna, men hittade {actual_items} objekt",
  "identities.messages.4000024": "minst {min_items} objekt tillåtna, men hittade {actual_items} objekt",
  "identities.messages.4000025": "objekt vid index {index_a} och {index_b} är lika",
  "identities.messages.4000026": "förväntade {allowed_types_list}, men var {actual_type}",
  "identities.messages.4000027": "Ett konto med samma identifierare (e-post, telefon, användarnamn, ...) finns redan. Logga in på ditt befintliga konto och länka din sociala profil på inställningssidan.",
  "identities.messages.4000028": "Du försökte logga in med {credential_identifier_hint} som redan används av ett annat konto. Du kan logga in med {available_credential_types_list}. Du kan logga in med någon av följande sociala inloggningsleverantörer: {Available_oidc_providers_list}.",
  "identities.messages.4000029": "måste vara lika med konstant {expected}",
  "identities.messages.4000030": "const misslyckades",
  "identities.messages.4000031": "Lösenordet kan inte användas eftersom det är för likt identifieraren.",
  "identities.messages.4000032": "Lösenordet måste vara minst {min_length} tecken långt, men är {actual_length}.",
  "identities.messages.4000033": "Lösenordet får vara högst {max_length} tecken långt, men är {actual_length}.",
  "identities.messages.4000034": "Lösenordet har hittats vid dataintrång och får inte längre användas.",
  "identities.messages.4000035": "Det här kontot finns inte eller har inte konfigurerat inloggning med kod.",
  "identities.messages.4000036": "De angivna egenskaperna matchar inte de egenskaper som tidigare associerats med detta flöde.",
  "identities.messages.4010001": "Inloggningsflödet upphörde för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4010002": "Kunde inte hitta en strategi att logga in dig med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010003": "Kunde inte hitta en strategi att registrera dig med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010004": "Kunde inte hitta en strategi för att uppdatera dina inställningar. Fyllde du i formuläret korrekt?",
  "identities.messages.4010005": "Kunde inte hitta en strategi att återställa ditt konto med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010006": "Kunde inte hitta en strategi att verifiera ditt konto med. Fyllde du i formuläret korrekt?",
  "identities.messages.4010007": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4010008": "Inloggningskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.4010009": "Länkade autentiseringsuppgifter matchar inte.",
  "identities.messages.4010010": "Adressen du angav matchar inte några kända adresser i det aktuella kontot.",
  "identities.messages.4040001": "Registreringsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, försök igen.",
  "identities.messages.4040002": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4040003": "Registreringskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.4050001": "Inställningsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4060001": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4060002": "Återställningsflödet nådde ett feltillstånd och måste försökas igen.",
  "identities.messages.4060004": "Återställningstoken är ogiltig eller har redan använts. Var vänlig försök flödet igen.",
  "identities.messages.4060005": "Återställningsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4060006": "Återställningskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.4070001": "Verifieringstoken är ogiltig eller har redan använts. Var vänlig försök flödet igen.",
  "identities.messages.4070002": "Begäran har redan slutförts framgångsrikt och kan inte göras igen.",
  "identities.messages.4070003": "Verifieringsflödet nådde ett feltillstånd och måste försökas igen.",
  "identities.messages.4070005": "Verifieringsflödet gick ut för {expired_at_unix_since_minutes} minuter sedan, var vänlig försök igen.",
  "identities.messages.4070006": "Verifieringskoden är ogiltig eller har redan använts. Var vänlig försök igen.",
  "identities.messages.5000001": "{reason}",
  "login.cancel-button": "Avbryt",
  "login.cancel-label": "Fel konto?",
  "login.forgot-password": "Glömt lösenord?",
  "login.logged-in-as-label": "Du är inloggad som:",
  "login.logout-button": "Logga ut",
  "login.logout-label": "Är det något som inte fungerar?",
  "login.registration-button": "Skapa konto",
  "login.registration-label": "Har du inget konto?",
  "login.subtitle-oauth2": "Att autentisera {clientName}",
  "login.title": "Logga in",
  "login.title-aal2": "Tvåfaktorsautentisering",
  "login.subtitle-aal2": "Välj ett sätt att slutföra din tvåfaktorsautentisering",
  "login.code.subtitle": "En verifieringskod kommer att skickas via e-post",
  "login.webauthn.subtitle": "Förbered din WebAuthN-enhet",
  "login.totp.subtitle": "Ange koden som genererats av din autentiseringsapp",
  "login.lookup_secret.subtitle": "Ange en av dina 8-siffriga återställningskoder",
  "login.title-refresh": "Bekräfta att det är du",
  "login.2fa.go-back": "Något fungerar inte?",
  "login.2fa.go-back.link": "Gå tillbaka",
  "login.2fa.method.go-back": "Välj en annan metod",
  "logout.accept-button": "Ja",
  "logout.reject-button": "Nej",
  "logout.title": "Vill du logga ut?",
  "recovery.login-button": "Logga in",
  "recovery.login-label": "Kan du ditt inlogg?",
  "recovery.title": "Återställ ditt konto",
  "registration.login-button": "Logga in",
  "registration.login-label": "Har du redan ett konto?",
  "registration.subtitle-oauth2": "Att autentisera {clientName}",
  "registration.title": "Skapa ett konto",
  "settings.navigation-back-button": "Tillbaka",
  "settings.navigation-backup-codes": "2FA backupkoder",
  "settings.navigation-logout": "Logga ut",
  "settings.navigation-oidc": "Social Inloggning",
  "settings.navigation-password": "Lösenord",
  "settings.navigation-profile": "Profil",
  "settings.navigation-totp": "Autentiserings App",
  "settings.navigation-webauthn": "Hårdvaru Tokens",
  "settings.navigation-passkey": "Passkeys",
  "settings.subtitle-instructions": "Här kan du hantera inställningar relaterade till ditt konto. Tänk på att vissa åtgärder kräver att du autentiseras på nytt.",
  "settings.title": "Kontoinställningar",
  "verification.registration-button": "Skapa konto",
  "verification.registration-label": "Har du inget konto?",
  "verification.title": "Verifiera ditt konto",
  "verification.back-button": "Tillbaka",
  "two-step.code.description": "En verifieringskod kommer att skickas till din e-post",
  "two-step.code.title": "E-postkod",
  "two-step.passkey.description": "Använd din enhets fingeravtryck eller ansiktsigenkänning",
  "two-step.passkey.title": "Passerkod (rekommenderad)",
  "two-step.password.description": "Ange ditt lösenord kopplat till ditt konto",
  "two-step.password.title": "Lösenord",
  "two-step.webauthn.title": "Säkerhetsnyckel",
  "two-step.webauthn.description": "Använd din säkerhetsnyckel för att autentisera",
  "two-step.totp.title": "Använd din autentiseringsapp (TOTP)",
  "two-step.totp.description": "Använd en 6-siffrig engångskod från din autentiseringsapp",
  "two-step.lookup_secret.title": "Reservåterställningskod",
  "two-step.lookup_secret.description": "Använd en av dina 8-siffriga reservkoder för att autentisera",
  "identities.messages.4000037": "Detta konto finns inte eller har ingen inloggningsmetod konfigurerad.",
  "identities.messages.4000038": "Captcha-verifiering misslyckades, försök igen.",
  "identities.messages.1010020": "",
  "input.placeholder": "Ange din {placeholder}",
  "card.header.description.login": "Logga in med {identifierLabel}",
  "card.header.description.registration": "Registrera dig med {identifierLabel}",
  "card.header.parts.code": "en kod skickad till dig",
  "card.header.parts.totp": "din autentiseringsapp",
  "card.header.parts.lookup_secret": "en säkerhetskopieringskod",
  "card.header.parts.identifier-first": "din {identifierLabel}",
  "card.header.parts.oidc": "en social leverantör",
  "card.header.parts.passkey": "en Passkey",
  "card.header.parts.password.login": "din {identifierLabel} och lösenord",
  "card.header.parts.password.registration": "din {identifierLabel} och ett lösenord",
  "card.header.parts.webauthn": "en säkerhetsnyckel",
  "forms.label.forgot-password": "Glömt Lösenord?",
  "login.subtitle": "Logga in med {parts}",
  "login.subtitle-refresh": "Bekräfta din identitet med {parts}",
  "misc.or": "eller",
  "recovery.subtitle": "Ange e-postadressen kopplad till ditt konto för att få en engångskod för åtkomst",
  "registration.subtitle": "Registrera dig med {parts}",
  "settings.subtitle": "Uppdatera dina kontoinställningar",
  "verification.subtitle": "Ange e-postadressen kopplad till ditt konto för att verifiera det",
  "settings.totp.info.linked": "Du har för närvarande en autentiseringsapp kopplad.",
  "settings.totp.info.not-linked": "För att aktivera, skanna QR-koden med din autentiserare och ange koden.",
  "settings.totp.title": "",
  "settings.totp.description": "Lägg till en TOTP-autentiseringsapp till ditt konto för att förbättra säkerheten på ditt konto. Populära autentiseringsappar är LastPass och Google Authenticator.",
  "settings.lookup_secret.description": "Återställningskoder är en säker backup för 2FA, vilket gör att du kan återfå åtkomst till ditt konto om du tappar bort din 2FA-enhet.",
  "settings.lookup_secret.title": "Backup-återställningskoder (andra faktorn)",
  "settings.navigation.title": "Kontoinställningar",
  "settings.oidc.description": "Anslut en social inloggningsleverantör till ditt konto.",
  "settings.oidc.info": "Anslutna konton från dessa leverantörer kan användas för att logga in på ditt konto",
  "settings.oidc.title": "Anslutna konton",
  "settings.passkey.description": "Hantera dina lösenordsinställningar",
  "settings.passkey.info": "Hantera dina lösenordsinställningar",
  "settings.passkey.title": "Hantera lösenord",
  "settings.password.description": "Ändra ditt lösenord",
  "settings.password.title": "Ändra lösenord",
  "settings.profile.description": "Uppdatera din profilinformation",
  "settings.profile.title": "Profilinställningar",
  "settings.title-lookup-secret": "Hantera 2FA Backup Recovery-koder",
  "settings.title-navigation": "Kontoinställningar",
  "settings.title-oidc": "Social logga in",
  "settings.title-passkey": "Hantera lösenord",
  "settings.title-password": "Ändra lösenord",
  "settings.title-profile": "Profilinställningar",
  "settings.title-totp": "Hantera 2FA TOTP Authenticator-appen",
  "settings.title-webauthn": "Hantera maskinvarutokens",
  "settings.webauthn.description": "Hantera inställningarna för din maskinvarutoken",
  "settings.webauthn.info": "Hårdvarutokens används för andrafaktorsautentisering eller som förstafaktor med lösenordsnycklar",
  "settings.webauthn.title": "Hantera maskinvarutokens",
  "card.footer.select-another-method": "Välj en annan metod",
  "account-linking.title": "Länka ditt konto",
  "property.password": "lösenord",
  "property.email": "e-post",
  "property.phone": "telefon",
  "property.username": "användarnamn",
  "property.identifier": "identifier",
  "property.code": "kod",
  "consent.title": "Auktorisera {party}",
  "consent.subtitle": "En tredjepartsapplikation vill få tillgång till information kopplad till ditt konto {identifier}.",
  "consent.scope.openid.title": "Identitet",
  "consent.scope.openid.description": "Gör det möjligt för applikationen att verifiera din identitet. Detta krävs för autentisering och en pålitlig inloggningsupplevelse.",
  "consent.scope.offline_access.title": "Offline-åtkomst",
  "consent.scope.offline_access.description": "Gör det möjligt för denna applikation att hålla dig inloggad även när du inte aktivt använder den.",
  "consent.scope.profile.title": "Profilinformation",
  "consent.scope.profile.description": "Ger tillgång till dina grundläggande profiluppgifter, inklusive ditt användarnamn, förnamn och efternamn.",
  "consent.scope.email.title": "E-postadress",
  "consent.scope.email.description": "Hämta din e-postadress och dess verifieringsstatus.",
  "consent.scope.address.title": "Fysisk adress",
  "consent.scope.address.description": "Få åtkomst till din postadress.",
  "consent.scope.phone.title": "Telefonnummer",
  "consent.scope.phone.description": "Hämta ditt telefonnummer och dess verifieringsstatus.",
  "error.action.go-back": "",
  "error.footer.copy": "",
  "error.footer.text": "",
  "error.title.what-can-i-do": "",
  "error.title.what-happened": "",
  "error.instructions": ""
}
